import { innerWidthThreshold } from 'utils/constants/app/magic-numbers-app';
import { GLOBALS } from 'utils/generic/global-variables';

export const TABLET_BY_DEFAULT = 3;

export const isMobile = (): boolean => {
  if (typeof window !== 'undefined') {
    if (window.fromNext) {
      return (
        /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
        window.innerWidth < innerWidthThreshold.WINDOW_WIDTH_THRESHOLD_1200
      );
    }

    return typeof window.isMobile !== 'undefined'
      ? +window.isMobile === 1 ||
          (+window.isTablet === 1 &&
            GLOBALS.appConfigs.tabletByDefault === TABLET_BY_DEFAULT)
      : window.innerWidth < innerWidthThreshold.WINDOW_WIDTH_THRESHOLD_1200;
  }

  return false;
};
